import { makeStyles } from '@material-ui/core/styles';
import { Colors } from '../../layout/theme-next';

const ITEM_GAP = 2;
const CONNECTION_WIDTH = 1;

const CONNECTION_HEIGHT = ITEM_GAP + 6;
const CONNECTION_HEIGHT_ALONE = ITEM_GAP + 3;
const CONNECTION_RADIUS = 2;
const CONNECTION_LAST_OFFSET = CONNECTION_HEIGHT - CONNECTION_RADIUS;

export default makeStyles((theme) => ({
  root: {
    paddingBottom: theme.spacing(2),
    marginTop: theme.spacing(1),
    borderBottom: `1px solid ${theme.palette.divider}`,
  },
  deviationToggle: {
    display: 'flex',
    alignItems: 'center',
    marginBottom: theme.spacing(1),
  },
  deviationToggleLabel: {
    marginLeft: theme.spacing(1),
    fontSize: 14,
  },
  paddedItems: {
    marginLeft: theme.spacing(1),
  },
  stepTitle: {
    fontWeight: 600,
    fontSize: 14,
    lineHeight: 1.25,
    color: Colors.textBlack,
    marginBottom: theme.spacing(1),
  },
  itemTitle: {
    fontWeight: 600,
    fontSize: 12,
    lineHeight: 1.25,
    color: Colors.textBlack,
    marginBottom: theme.spacing(1),
  },
  item: {
    paddingBottom: 1,
    paddingTop: theme.spacing(ITEM_GAP),
  },
  paddedItem: {
    paddingLeft: theme.spacing(CONNECTION_WIDTH),
    position: 'relative',

    '&::before': {
      content: '""',
      position: 'absolute',
      top: 0,
      left: 0,
      width: 1,
      bottom: 0,
      borderLeft: `1px solid ${theme.palette.divider}`,
    },
    '&::after': {
      content: '""',
      position: 'absolute',
      top: theme.spacing(CONNECTION_HEIGHT),
      left: 0,
      width: theme.spacing(CONNECTION_WIDTH),
      height: 0,
      borderBottom: `1px solid ${theme.palette.divider}`,
    },
  },
  itemFirst: {
    // placeholder
  },
  itemLast: {
    '&::before': {
      height: theme.spacing(CONNECTION_LAST_OFFSET),
      bottom: 'auto',
    },
    '&::after': {
      top: theme.spacing(CONNECTION_LAST_OFFSET),
      height: theme.spacing(CONNECTION_RADIUS),
      borderLeft: `1px solid ${theme.palette.divider}`,
      borderBottomLeftRadius: theme.shape.borderRadius,
    },
  },
  itemAlone: {
    '&::after': {
      top: theme.spacing(CONNECTION_HEIGHT_ALONE),
    },
  },
  skeleton: {
    borderRadius: theme.shape.borderRadius,
  },
}));
